import { FC } from 'react';
import DesktopLogo from '../../assets/desktop_inplay_logo.png';
import TabletLogo from '../../assets/tablet_inplay_logo.png';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { RenderInPlayLogoProps } from './inPlayLogo.type';
import { getIdAttributes } from '../../utils/helper';

const RenderInPlayLogo: FC<RenderInPlayLogoProps> = (props) => {
  const idPrefix: string = 'inplay-logo';
  const { isDesktop } = useResponsiveLayout();

  return (
    <img
      src={isDesktop ? DesktopLogo : TabletLogo}
      alt="RenderInPlay Logo"
      className={`w-auto object-contain mt-10  ${props.className ?? 'h-8'}`}
      {...getIdAttributes(idPrefix, 'image')}
    />
  );
};

export default RenderInPlayLogo;
